import { z } from "zod";

export const ContactFormSchema = z.object({
  name: z.string().min(1, "Bitte gib deinen Namen ein."),
  mail: z.email({ message: "Bitte gib eine gültige E-Mail-Adresse ein." }),
  message: z.string().min(1, "Bitte gib eine Nachricht ein."),
});

export type ContactFormBody = z.infer<typeof ContactFormSchema>;
